import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";


/**✅ getCampaignsThunk Thunk */
export const getCampaignsThunk = createAsyncThunk(
    "campaigns/getCampaignsThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getCampaigns") {
            if (state.campaigns?.getcampaigns?.length > 0) {
                return state.campaigns.getcampaigns;
            }
        }

        try {
            const response = await api.post(API_ROUTES.CAMPAIGNS, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Campaign");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);


/**✅ getCampaignStatusThunk Thunk **/
export const getCampaignStatusThunk = createAsyncThunk(
    "campaigns/getCampaignStatusThunk",
    async ({ credentials }, { rejectWithValue }) => {

        try {
            const response = await api.post(API_ROUTES.CAMPAIGNS_STATUS, credentials)

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch branches");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);



/**✅ getCampaignTagUsersThunk Thunk **/
export const getCampaignTagUsersThunk = createAsyncThunk(
    "campaigns/getCampaignTagUsersThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {

        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            "client_id": user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.TAGWISE_USERS, payload)

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            } 

            return rejectWithValue(message || "Failed to fetch branches");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);




/**✅ getCampaignStatusThunk Thunk **/
export const getCampaignInputParamsThunk = createAsyncThunk(
    "campaigns/getCampaignInputParamsThunk",
    async (_, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;


        if (state.campaigns?.campaignInputParams?.length > 0) {
            return state.campaigns.campaignInputParams;
        }

        try {
            const response = await api.post(API_ROUTES.CAMPAIGN_INPUTS, { "client_id": user?.client_id })

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch branches");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);


/**✅ createCampaignThunkt Thunk **/
export const createCampaignThunk = createAsyncThunk(
    "campaigns/createCampaignThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.CREATE_CAMPAIGN, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);
